import type { ReactElement } from 'react'
import { ProfilesList } from '~/components/Global/Elements/ProfilesList/ProfilesList'
import { useUsersPicture } from '../queries/useUsersPicture'
import type { UserHeadResponse, UserPicture } from '../types'
export type UsersListProps = {
  userIds?: number[]
  users?: UserHeadResponse[]
  className?: string
  tooltipText?: string
  align?: 'center' | 'left' | 'right'
}

export const UsersList = ({
  userIds,
  users,
  className,
  align = 'center',
  tooltipText
}: UsersListProps): ReactElement => {
  const usersPictures = useUsersPicture({
    userIds: userIds ?? users?.map((user) => user.id) ?? []
  })
  if (!userIds && !users) {
    throw new Error('userIds or users are required')
  }

  let profiles: UserPicture[] = usersPictures
    ?.map(({ data: userPicture }) => userPicture)
    .filter((userPicture) => userPicture !== undefined && userPicture !== null)

  if (profiles.length === 0 && users) {
    profiles = users.map((user) => ({
      profilePicUrl: null,
      user: user
    }))
  }

  return (
    <ProfilesList
      profilePictures={profiles}
      tooltipText={tooltipText}
      className={className}
      align={align}
    />
  )
}
